import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Card from "components/Card";
import CardSkeleton from "components/Skeletons/Card.Skeleton";
import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";
import { useSelector } from "react-redux";

function BoxPortfolioTradeCoin() {
  const portfolioSingleTrade = useSelector(
    (state) => state.portfolio.portfolioSingleTrade?.data
  );

  return (
    <>
      {portfolioSingleTrade ? (
        <Grid container spacing={1}>
          <Grid item xs={12} mt={2}>
            <Card>
              <Box
                display="flex"
                marginBottom={2}
                alignItems="center"
                dir="ltr"
              >
                <img
                  width={"25px"}
                  height={"25px"}
                  src={`${DefaultUrlWeb}${portfolioSingleTrade?.imageUrl}`}
                  alt={portfolioSingleTrade?.name}
                />

                <Box display="flex" marginLeft={1}>
                  <Typography
                    variant="h5"
                    marginLeft={0.5}
                    color="text.secondary"
                  >
                    Balance:
                  </Typography>
                  <Typography
                    variant="h6"
                    color="text.main"
                    fontWeight={600}
                    marginLeft={0.5}
                  >
                    <NumberFormats value={portfolioSingleTrade?.totalBalance} />
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    marginLeft={0.5}
                    color="text.secondary"
                  >
                    {portfolioSingleTrade?.name}
                  </Typography>
                </Box>
              </Box>

              <Grid container spacing={1} dir="ltr">
                <Grid item xs={6} mt={2}>
                  <Box>
                    <Typography
                      component="span"
                      variant="h6"
                      color="text.secondary"
                    >
                      Value Blnc:{" "}
                    </Typography>

                    <Box mt={2}>
                      <Typography component="span" variant="h6">
                        <NumberFormats
                          value={portfolioSingleTrade?.costMarketUSDT}
                        />
                      </Typography>

                      <Typography
                        component="span"
                        variant="subtitle1"
                        color="text.secondary"
                        pl={1}
                      >
                        USDT
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={6} mt={2}>
                  <Box>
                    <Typography
                      component="span"
                      variant="h6"
                      color="secondary.main"
                    >
                      Market Price
                    </Typography>

                    <Box mt={2}>
                      <Typography component="span" variant="h6">
                        <NumberFormats
                          value={portfolioSingleTrade?.priceMarketUSDT}
                        />
                      </Typography>

                      <Typography
                        component="span"
                        variant="subtitle1"
                        color="text.secondary"
                        pl={1}
                      >
                        USDT
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={6} mt={2}>
                  <Box>
                    <Typography
                      component="span"
                      variant="h6"
                      color="success.main"
                      pb={4}
                    >
                      Buy Average
                    </Typography>
                    <Box mt={2}>
                      <Typography component="span" variant="h6">
                        <NumberFormats
                          value={portfolioSingleTrade?.buyFilled}
                        />
                      </Typography>

                      <Typography
                        component="span"
                        variant="subtitle1"
                        color="text.secondary"
                        pl={1}
                      >
                        {portfolioSingleTrade?.name}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography component="span" variant="h6">
                        <NumberFormats
                          value={portfolioSingleTrade?.buyAvgUSDT}
                        />
                      </Typography>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        color="text.secondary"
                        pl={1}
                      >
                        USDT
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={6} mt={2}>
                  <Box>
                    <Typography
                      component="span"
                      variant="h6"
                      color="error.main"
                      pb={4}
                    >
                      Sell Average
                    </Typography>
                    <Box mt={2}>
                      <Typography component="span" variant="h6">
                        <NumberFormats
                          value={portfolioSingleTrade?.sellFilled}
                        />
                      </Typography>

                      <Typography
                        component="span"
                        variant="subtitle1"
                        color="text.secondary"
                        pl={1}
                      >
                        {portfolioSingleTrade?.name}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography component="span" variant="h6">
                        <NumberFormats
                          value={portfolioSingleTrade?.sellAvgUSDT}
                        />
                      </Typography>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        color="text.secondary"
                        pl={1}
                      >
                        USDT
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      ) : (
        <CardSkeleton heightSize={172} />
      )}
    </>
  );
}
export default BoxPortfolioTradeCoin;
